{
  "nm": "no background",
  "ddd": 0,
  "h": 80,
  "w": 80,
  "meta": { "g": "LottieFiles Figma v50" },
  "layers": [
    {
      "ty": 0,
      "nm": "Logo",
      "sr": 1,
      "st": 0,
      "op": 61.12,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": true,
      "ao": 0,
      "ks": {
        "a": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [7.47, 11.2],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [7.47, 11.2],
              "t": 30
            },
            { "s": [7.47, 11.2], "t": 60 }
          ]
        },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 30
            },
            { "s": [100, 100], "t": 60 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [40.47, 40.2],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [40.47, 40.2],
              "t": 30
            },
            { "s": [40.47, 40.2], "t": 60 }
          ]
        },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [0],
              "t": 30
            },
            { "s": [0], "t": 60 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 30
            },
            { "s": [100], "t": 60 }
          ]
        }
      },
      "masksProperties": [
        {
          "nm": "",
          "inv": false,
          "mode": "a",
          "x": { "a": 0, "k": 0 },
          "o": { "a": 0, "k": 100 },
          "pt": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [0, 0],
                      [14.93, 0],
                      [14.93, 22.4],
                      [0, 22.4]
                    ]
                  }
                ],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [0, 0],
                      [14.93, 0],
                      [14.93, 22.4],
                      [0, 22.4]
                    ]
                  }
                ],
                "t": 30
              },
              {
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "o": [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [0, 0],
                      [14.93, 0],
                      [14.93, 22.4],
                      [0, 22.4]
                    ]
                  }
                ],
                "t": 60
              }
            ]
          }
        }
      ],
      "w": 80,
      "h": 80,
      "refId": "1",
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "Ellipse 1",
      "sr": 1,
      "st": 0,
      "op": 61.12,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [28, 28],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [28, 28],
              "t": 30
            },
            { "s": [28, 28], "t": 60 }
          ]
        },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100, 100],
              "t": 30
            },
            { "s": [100, 100], "t": 60 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [40, 40],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [40, 40],
              "t": 30
            },
            { "s": [40, 40], "t": 60 }
          ]
        },
        "r": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [-60.85],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [90],
              "t": 30
            },
            { "s": [268.34], "t": 60 }
          ]
        },
        "sa": { "a": 0, "k": 0 },
        "o": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 0
            },
            {
              "o": { "x": 0, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100],
              "t": 30
            },
            { "s": [100], "t": 60 }
          ]
        }
      },
      "shapes": [
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0.19, 1.71],
                      [2.5, 3.74],
                      [5.12, 2.12],
                      [5.43, -1.08],
                      [3.92, -3.92],
                      [1.08, -5.43],
                      [-2.12, -5.12],
                      [-4.6, -3.08],
                      [-4.43, -0.5],
                      [0, 1.73],
                      [0, 0],
                      [1.71, 0.25],
                      [2.71, 1.81],
                      [1.65, 3.97],
                      [-0.84, 4.22],
                      [-3.04, 3.04],
                      [-4.22, 0.84],
                      [-3.97, -1.65],
                      [-2.39, -3.58],
                      [-0.46, -3.2],
                      [-1.73, 0],
                      [0, 0]
                    ],
                    "o": [
                      [1.73, 0],
                      [-0.5, -4.43],
                      [-3.08, -4.6],
                      [-5.12, -2.12],
                      [-5.43, 1.08],
                      [-3.92, 3.92],
                      [-1.08, 5.43],
                      [2.12, 5.12],
                      [3.74, 2.5],
                      [1.71, 0.19],
                      [0, 0],
                      [0, -1.73],
                      [-3.2, -0.46],
                      [-3.58, -2.39],
                      [-1.65, -3.97],
                      [0.84, -4.22],
                      [3.04, -3.04],
                      [4.22, -0.84],
                      [3.97, 1.65],
                      [1.81, 2.71],
                      [0.25, 1.71],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [52.88, 28],
                      [55.83, 24.88],
                      [51.28, 12.44],
                      [38.72, 2.13],
                      [22.54, 0.54],
                      [8.2, 8.2],
                      [0.54, 22.54],
                      [2.13, 38.72],
                      [12.44, 51.28],
                      [24.88, 55.83],
                      [28, 52.88],
                      [28, 52.88],
                      [24.89, 49.53],
                      [15.92, 46.09],
                      [7.9, 36.32],
                      [6.67, 23.76],
                      [12.62, 12.62],
                      [23.76, 6.67],
                      [36.32, 7.9],
                      [46.09, 15.92],
                      [49.53, 24.89],
                      [52.88, 28],
                      [52.88, 28]
                    ]
                  }
                ],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0.19, 1.71],
                      [2.5, 3.74],
                      [5.12, 2.12],
                      [5.43, -1.08],
                      [3.92, -3.92],
                      [1.08, -5.43],
                      [-2.12, -5.12],
                      [-4.6, -3.08],
                      [-4.43, -0.5],
                      [0, 1.73],
                      [0, 0],
                      [1.71, 0.25],
                      [2.71, 1.81],
                      [1.65, 3.97],
                      [-0.84, 4.22],
                      [-3.04, 3.04],
                      [-4.22, 0.84],
                      [-3.97, -1.65],
                      [-2.39, -3.58],
                      [-0.46, -3.2],
                      [-1.73, 0],
                      [0, 0]
                    ],
                    "o": [
                      [1.73, 0],
                      [-0.5, -4.43],
                      [-3.08, -4.6],
                      [-5.12, -2.12],
                      [-5.43, 1.08],
                      [-3.92, 3.92],
                      [-1.08, 5.43],
                      [2.12, 5.12],
                      [3.74, 2.5],
                      [1.71, 0.19],
                      [0, 0],
                      [0, -1.73],
                      [-3.2, -0.46],
                      [-3.58, -2.39],
                      [-1.65, -3.97],
                      [0.84, -4.22],
                      [3.04, -3.04],
                      [4.22, -0.84],
                      [3.97, 1.65],
                      [1.81, 2.71],
                      [0.25, 1.71],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [52.88, 28],
                      [55.83, 24.88],
                      [51.28, 12.44],
                      [38.72, 2.13],
                      [22.54, 0.54],
                      [8.2, 8.2],
                      [0.54, 22.54],
                      [2.13, 38.72],
                      [12.44, 51.28],
                      [24.88, 55.83],
                      [28, 52.88],
                      [28, 52.88],
                      [24.89, 49.53],
                      [15.92, 46.09],
                      [7.9, 36.32],
                      [6.67, 23.76],
                      [12.62, 12.62],
                      [23.76, 6.67],
                      [36.32, 7.9],
                      [46.09, 15.92],
                      [49.53, 24.89],
                      [52.88, 28],
                      [52.88, 28]
                    ]
                  }
                ],
                "t": 30
              },
              {
                "s": [
                  {
                    "c": true,
                    "i": [
                      [0, 0],
                      [0.19, 1.71],
                      [2.5, 3.74],
                      [5.12, 2.12],
                      [5.43, -1.08],
                      [3.92, -3.92],
                      [1.08, -5.43],
                      [-2.12, -5.12],
                      [-4.6, -3.08],
                      [-4.43, -0.5],
                      [0, 1.73],
                      [0, 0],
                      [1.71, 0.25],
                      [2.71, 1.81],
                      [1.65, 3.97],
                      [-0.84, 4.22],
                      [-3.04, 3.04],
                      [-4.22, 0.84],
                      [-3.97, -1.65],
                      [-2.39, -3.58],
                      [-0.46, -3.2],
                      [-1.73, 0],
                      [0, 0]
                    ],
                    "o": [
                      [1.73, 0],
                      [-0.5, -4.43],
                      [-3.08, -4.6],
                      [-5.12, -2.12],
                      [-5.43, 1.08],
                      [-3.92, 3.92],
                      [-1.08, 5.43],
                      [2.12, 5.12],
                      [3.74, 2.5],
                      [1.71, 0.19],
                      [0, 0],
                      [0, -1.73],
                      [-3.2, -0.46],
                      [-3.58, -2.39],
                      [-1.65, -3.97],
                      [0.84, -4.22],
                      [3.04, -3.04],
                      [4.22, -0.84],
                      [3.97, 1.65],
                      [1.81, 2.71],
                      [0.25, 1.71],
                      [0, 0],
                      [0, 0]
                    ],
                    "v": [
                      [52.88, 28],
                      [55.83, 24.88],
                      [51.28, 12.44],
                      [38.72, 2.13],
                      [22.54, 0.54],
                      [8.2, 8.2],
                      [0.54, 22.54],
                      [2.13, 38.72],
                      [12.44, 51.28],
                      [24.88, 55.83],
                      [28, 52.88],
                      [28, 52.88],
                      [24.89, 49.53],
                      [15.92, 46.09],
                      [7.9, 36.32],
                      [6.67, 23.76],
                      [12.62, 12.62],
                      [23.76, 6.67],
                      [36.32, 7.9],
                      [46.09, 15.92],
                      [49.53, 24.89],
                      [52.88, 28],
                      [52.88, 28]
                    ]
                  }
                ],
                "t": 60
              }
            ]
          }
        },
        {
          "ty": "gf",
          "bm": 0,
          "hd": false,
          "nm": "",
          "e": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [55.681800842285156, 37.767398834228516],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [55.681800842285156, 37.767398834228516],
                "t": 30
              },
              { "s": [55.681800842285156, 37.767398834228516], "t": 60 }
            ]
          },
          "g": {
            "p": 2,
            "k": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [
                    0, 0.8549411851191053, 0.3216078537725935,
                    0.38827451646561717, 1, 0.964745100142909,
                    0.7059215861582289, 0.3216078537725935
                  ],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [
                    0, 0.8549411851191053, 0.3216078537725935,
                    0.38827451646561717, 1, 0.964745100142909,
                    0.7059215861582289, 0.3216078537725935
                  ],
                  "t": 30
                },
                {
                  "s": [
                    0, 0.8549411851191053, 0.3216078537725935,
                    0.38827451646561717, 1, 0.964745100142909,
                    0.7059215861582289, 0.3216078537725935
                  ],
                  "t": 60
                }
              ]
            }
          },
          "t": 1,
          "a": { "a": 0, "k": 0 },
          "h": { "a": 0, "k": 0 },
          "s": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 37.767398834228516],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [0, 37.767398834228516],
                "t": 30
              },
              { "s": [0, 37.767398834228516], "t": 60 }
            ]
          },
          "r": 1,
          "o": {
            "a": 1,
            "k": [
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 0
              },
              {
                "o": { "x": 0, "y": 0 },
                "i": { "x": 1, "y": 1 },
                "s": [100],
                "t": 30
              },
              { "s": [100], "t": 60 }
            ]
          }
        }
      ],
      "ind": 2
    }
  ],
  "v": "5.7.0",
  "fr": 60,
  "op": 60.12,
  "ip": 0,
  "assets": [
    {
      "nm": "[Asset] Logo",
      "id": "1",
      "layers": [
        {
          "ty": 4,
          "nm": "Vector",
          "sr": 1,
          "st": 0,
          "op": 61.12,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [5.11, 9.16],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [5.11, 9.16],
                  "t": 30
                },
                { "s": [5.11, 9.16], "t": 60 }
              ]
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 30
                },
                { "s": [100, 100], "t": 60 }
              ]
            },
            "sk": { "a": 0, "k": 0 },
            "p": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [6.1, 12.92],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [6.1, 12.92],
                  "t": 30
                },
                { "s": [6.1, 12.92], "t": 60 }
              ]
            },
            "r": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [0],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [0],
                  "t": 30
                },
                { "s": [0], "t": 60 }
              ]
            },
            "sa": { "a": 0, "k": 0 },
            "o": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 30
                },
                { "s": [100], "t": 60 }
              ]
            }
          },
          "ef": [],
          "shapes": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "",
              "d": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 0],
                          [1.03, 0],
                          [0, 1.03],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.01, 0.21],
                          [0, 0],
                          [0, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0.01],
                          [0, 0.04],
                          [0.02, 0.1],
                          [0.44, 0.5],
                          [0.11, 0.1],
                          [0.03, 0.02],
                          [0, 0],
                          [0, 0],
                          [0, 0.4],
                          [-0.88, 0.15],
                          [0, 0],
                          [1.18, -1.87],
                          [-0.03, -0.69],
                          [-0.04, -0.05],
                          [-0.06, -0.07],
                          [-0.29, -0.24],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.12, -0.64],
                          [-0.01, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.58],
                          [-1.58, -0.57],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 1.03],
                          [-1.03, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, 0],
                          [0, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, -0.04],
                          [-0.01, -0.1],
                          [-0.13, -0.68],
                          [-0.1, -0.11],
                          [-0.03, -0.02],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.3],
                          [0, -0.92],
                          [0, 0],
                          [-0.89, 0.13],
                          [-0.62, 0.98],
                          [0.03, 0.05],
                          [0.05, 0.07],
                          [0.24, 0.29],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.4, 0.48],
                          [0.01, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0.65],
                          [0.56, 1.59],
                          [0, 0],
                          [4.12, -1.65],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [10.21, 12.72],
                          [10.21, 13.04],
                          [8.34, 14.91],
                          [6.47, 13.04],
                          [6.47, 10.12],
                          [6.47, 10.12],
                          [6.47, 8.18],
                          [6.47, 7.76],
                          [6.47, 7.76],
                          [6.47, 7.6],
                          [6.47, 7.59],
                          [6.47, 7.58],
                          [6.46, 7.56],
                          [6.45, 7.44],
                          [6.41, 7.15],
                          [5.53, 5.35],
                          [5.22, 5.04],
                          [5.14, 4.97],
                          [3.54, 3.37],
                          [3.08, 2.91],
                          [2.74, 1.84],
                          [4.28, 0],
                          [4.28, 0],
                          [0.77, 2.51],
                          [0, 5.03],
                          [0.11, 5.17],
                          [0.27, 5.38],
                          [1.06, 6.17],
                          [1.44, 6.55],
                          [1.92, 7.03],
                          [1.92, 7.03],
                          [2.72, 8.73],
                          [2.74, 8.87],
                          [2.74, 9.96],
                          [2.74, 9.97],
                          [2.74, 9.97],
                          [2.74, 13.04],
                          [3.06, 14.91],
                          [6.46, 18.31],
                          [6.47, 18.31],
                          [10.21, 12.72],
                          [10.21, 12.72]
                        ]
                      }
                    ],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 0],
                          [1.03, 0],
                          [0, 1.03],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.01, 0.21],
                          [0, 0],
                          [0, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0.01],
                          [0, 0.04],
                          [0.02, 0.1],
                          [0.44, 0.5],
                          [0.11, 0.1],
                          [0.03, 0.02],
                          [0, 0],
                          [0, 0],
                          [0, 0.4],
                          [-0.88, 0.15],
                          [0, 0],
                          [1.18, -1.87],
                          [-0.03, -0.69],
                          [-0.04, -0.05],
                          [-0.06, -0.07],
                          [-0.29, -0.24],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.12, -0.64],
                          [-0.01, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.58],
                          [-1.58, -0.57],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 1.03],
                          [-1.03, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, 0],
                          [0, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, -0.04],
                          [-0.01, -0.1],
                          [-0.13, -0.68],
                          [-0.1, -0.11],
                          [-0.03, -0.02],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.3],
                          [0, -0.92],
                          [0, 0],
                          [-0.89, 0.13],
                          [-0.62, 0.98],
                          [0.03, 0.05],
                          [0.05, 0.07],
                          [0.24, 0.29],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.4, 0.48],
                          [0.01, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0.65],
                          [0.56, 1.59],
                          [0, 0],
                          [4.12, -1.65],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [10.21, 12.72],
                          [10.21, 13.04],
                          [8.34, 14.91],
                          [6.47, 13.04],
                          [6.47, 10.12],
                          [6.47, 10.12],
                          [6.47, 8.18],
                          [6.47, 7.76],
                          [6.47, 7.76],
                          [6.47, 7.6],
                          [6.47, 7.59],
                          [6.47, 7.58],
                          [6.46, 7.56],
                          [6.45, 7.44],
                          [6.41, 7.15],
                          [5.53, 5.35],
                          [5.22, 5.04],
                          [5.14, 4.97],
                          [3.54, 3.37],
                          [3.08, 2.91],
                          [2.74, 1.84],
                          [4.28, 0],
                          [4.28, 0],
                          [0.77, 2.51],
                          [0, 5.03],
                          [0.11, 5.17],
                          [0.27, 5.38],
                          [1.06, 6.17],
                          [1.44, 6.55],
                          [1.92, 7.03],
                          [1.92, 7.03],
                          [2.72, 8.73],
                          [2.74, 8.87],
                          [2.74, 9.96],
                          [2.74, 9.97],
                          [2.74, 9.97],
                          [2.74, 13.04],
                          [3.06, 14.91],
                          [6.46, 18.31],
                          [6.47, 18.31],
                          [10.21, 12.72],
                          [10.21, 12.72]
                        ]
                      }
                    ],
                    "t": 30
                  },
                  {
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 0],
                          [1.03, 0],
                          [0, 1.03],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.01, 0.21],
                          [0, 0],
                          [0, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0.01],
                          [0, 0.04],
                          [0.02, 0.1],
                          [0.44, 0.5],
                          [0.11, 0.1],
                          [0.03, 0.02],
                          [0, 0],
                          [0, 0],
                          [0, 0.4],
                          [-0.88, 0.15],
                          [0, 0],
                          [1.18, -1.87],
                          [-0.03, -0.69],
                          [-0.04, -0.05],
                          [-0.06, -0.07],
                          [-0.29, -0.24],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.12, -0.64],
                          [-0.01, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.58],
                          [-1.58, -0.57],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 1.03],
                          [-1.03, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, 0],
                          [0, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, -0.04],
                          [-0.01, -0.1],
                          [-0.13, -0.68],
                          [-0.1, -0.11],
                          [-0.03, -0.02],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.3],
                          [0, -0.92],
                          [0, 0],
                          [-0.89, 0.13],
                          [-0.62, 0.98],
                          [0.03, 0.05],
                          [0.05, 0.07],
                          [0.24, 0.29],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.4, 0.48],
                          [0.01, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0.65],
                          [0.56, 1.59],
                          [0, 0],
                          [4.12, -1.65],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [10.21, 12.72],
                          [10.21, 13.04],
                          [8.34, 14.91],
                          [6.47, 13.04],
                          [6.47, 10.12],
                          [6.47, 10.12],
                          [6.47, 8.18],
                          [6.47, 7.76],
                          [6.47, 7.76],
                          [6.47, 7.6],
                          [6.47, 7.59],
                          [6.47, 7.58],
                          [6.46, 7.56],
                          [6.45, 7.44],
                          [6.41, 7.15],
                          [5.53, 5.35],
                          [5.22, 5.04],
                          [5.14, 4.97],
                          [3.54, 3.37],
                          [3.08, 2.91],
                          [2.74, 1.84],
                          [4.28, 0],
                          [4.28, 0],
                          [0.77, 2.51],
                          [0, 5.03],
                          [0.11, 5.17],
                          [0.27, 5.38],
                          [1.06, 6.17],
                          [1.44, 6.55],
                          [1.92, 7.03],
                          [1.92, 7.03],
                          [2.72, 8.73],
                          [2.74, 8.87],
                          [2.74, 9.96],
                          [2.74, 9.97],
                          [2.74, 9.97],
                          [2.74, 13.04],
                          [3.06, 14.91],
                          [6.46, 18.31],
                          [6.47, 18.31],
                          [10.21, 12.72],
                          [10.21, 12.72]
                        ]
                      }
                    ],
                    "t": 60
                  }
                ]
              }
            },
            {
              "ty": "gf",
              "bm": 0,
              "hd": false,
              "nm": "",
              "e": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [-0.5329509973526001, 1.121880054473877],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [-0.5329509973526001, 1.121880054473877],
                    "t": 30
                  },
                  { "s": [-0.5329509973526001, 1.121880054473877], "t": 60 }
                ]
              },
              "g": {
                "p": 20,
                "k": {
                  "a": 1,
                  "k": [
                    {
                      "o": { "x": 0, "y": 0 },
                      "i": { "x": 1, "y": 1 },
                      "s": [
                        0.019999999552965164, 0.20003921866650673,
                        0.000039215686274509805, 0.40396079004044627,
                        0.03999999910593033, 0.34121569574112987,
                        0.06278431743617152, 0.400039221646739,
                        0.07000000029802322, 0.5020000296854505,
                        0.13337255597348305, 0.400039221646739,
                        0.09000000357627869, 0.6392549234652052,
                        0.19611765027279945, 0.3961176532530317,
                        0.11999999731779099, 0.7529804068827162,
                        0.24317647099728676, 0.3961176532530317,
                        0.15000000596046448, 0.8392549115442762,
                        0.28239216983552073, 0.3961176532530317,
                        0.18000000715255737, 0.8980784374498854,
                        0.30984314859147166, 0.3961176532530317,
                        0.2199999988079071, 0.9372941213869581,
                        0.32552942216630076, 0.3961176532530317,
                        0.27000001072883606, 0.9490588265680799,
                        0.3333725589537153, 0.3961176532530317,
                        0.3499999940395355, 0.9529803949617872,
                        0.4157254952215681, 0.3686666744970808,
                        0.5199999809265137, 0.9686666685366163,
                        0.6274902182840834, 0.3059215801977644,
                        0.5600000023841858, 0.9725882369303236,
                        0.6784706074022779, 0.29415687501664256,
                        0.6600000262260437, 0.9569019633554945,
                        0.5020000296854505, 0.34513726413483714,
                        0.7400000095367432, 0.9490588265680799,
                        0.37650981128449534, 0.3804313796782026,
                        0.7900000214576721, 0.9490588265680799,
                        0.3333725589537153, 0.3961176532530317,
                        0.8100000023841858, 0.9020000058435926,
                        0.31376471698517894, 0.3961176532530317,
                        0.8500000238418579, 0.7882745224260816,
                        0.2588627594732771, 0.3961176532530317,
                        0.9100000262260437, 0.6000392395281324,
                        0.17650980830426308, 0.3961176532530317,
                        0.9700000286102295, 0.34121569574112987,
                        0.06278431743617152, 0.400039221646739, 1,
                        0.20003921866650673, 0.000039215686274509805,
                        0.40396079004044627
                      ],
                      "t": 0
                    },
                    {
                      "o": { "x": 0, "y": 0 },
                      "i": { "x": 1, "y": 1 },
                      "s": [
                        0.019999999552965164, 0.20003921866650673,
                        0.000039215686274509805, 0.40396079004044627,
                        0.03999999910593033, 0.34121569574112987,
                        0.06278431743617152, 0.400039221646739,
                        0.07000000029802322, 0.5020000296854505,
                        0.13337255597348305, 0.400039221646739,
                        0.09000000357627869, 0.6392549234652052,
                        0.19611765027279945, 0.3961176532530317,
                        0.11999999731779099, 0.7529804068827162,
                        0.24317647099728676, 0.3961176532530317,
                        0.15000000596046448, 0.8392549115442762,
                        0.28239216983552073, 0.3961176532530317,
                        0.18000000715255737, 0.8980784374498854,
                        0.30984314859147166, 0.3961176532530317,
                        0.2199999988079071, 0.9372941213869581,
                        0.32552942216630076, 0.3961176532530317,
                        0.27000001072883606, 0.9490588265680799,
                        0.3333725589537153, 0.3961176532530317,
                        0.3499999940395355, 0.9529803949617872,
                        0.4157254952215681, 0.3686666744970808,
                        0.5199999809265137, 0.9686666685366163,
                        0.6274902182840834, 0.3059215801977644,
                        0.5600000023841858, 0.9725882369303236,
                        0.6784706074022779, 0.29415687501664256,
                        0.6600000262260437, 0.9569019633554945,
                        0.5020000296854505, 0.34513726413483714,
                        0.7400000095367432, 0.9490588265680799,
                        0.37650981128449534, 0.3804313796782026,
                        0.7900000214576721, 0.9490588265680799,
                        0.3333725589537153, 0.3961176532530317,
                        0.8100000023841858, 0.9020000058435926,
                        0.31376471698517894, 0.3961176532530317,
                        0.8500000238418579, 0.7882745224260816,
                        0.2588627594732771, 0.3961176532530317,
                        0.9100000262260437, 0.6000392395281324,
                        0.17650980830426308, 0.3961176532530317,
                        0.9700000286102295, 0.34121569574112987,
                        0.06278431743617152, 0.400039221646739, 1,
                        0.20003921866650673, 0.000039215686274509805,
                        0.40396079004044627
                      ],
                      "t": 30
                    },
                    {
                      "s": [
                        0.019999999552965164, 0.20003921866650673,
                        0.000039215686274509805, 0.40396079004044627,
                        0.03999999910593033, 0.34121569574112987,
                        0.06278431743617152, 0.400039221646739,
                        0.07000000029802322, 0.5020000296854505,
                        0.13337255597348305, 0.400039221646739,
                        0.09000000357627869, 0.6392549234652052,
                        0.19611765027279945, 0.3961176532530317,
                        0.11999999731779099, 0.7529804068827162,
                        0.24317647099728676, 0.3961176532530317,
                        0.15000000596046448, 0.8392549115442762,
                        0.28239216983552073, 0.3961176532530317,
                        0.18000000715255737, 0.8980784374498854,
                        0.30984314859147166, 0.3961176532530317,
                        0.2199999988079071, 0.9372941213869581,
                        0.32552942216630076, 0.3961176532530317,
                        0.27000001072883606, 0.9490588265680799,
                        0.3333725589537153, 0.3961176532530317,
                        0.3499999940395355, 0.9529803949617872,
                        0.4157254952215681, 0.3686666744970808,
                        0.5199999809265137, 0.9686666685366163,
                        0.6274902182840834, 0.3059215801977644,
                        0.5600000023841858, 0.9725882369303236,
                        0.6784706074022779, 0.29415687501664256,
                        0.6600000262260437, 0.9569019633554945,
                        0.5020000296854505, 0.34513726413483714,
                        0.7400000095367432, 0.9490588265680799,
                        0.37650981128449534, 0.3804313796782026,
                        0.7900000214576721, 0.9490588265680799,
                        0.3333725589537153, 0.3961176532530317,
                        0.8100000023841858, 0.9020000058435926,
                        0.31376471698517894, 0.3961176532530317,
                        0.8500000238418579, 0.7882745224260816,
                        0.2588627594732771, 0.3961176532530317,
                        0.9100000262260437, 0.6000392395281324,
                        0.17650980830426308, 0.3961176532530317,
                        0.9700000286102295, 0.34121569574112987,
                        0.06278431743617152, 0.400039221646739, 1,
                        0.20003921866650673, 0.000039215686274509805,
                        0.40396079004044627
                      ],
                      "t": 60
                    }
                  ]
                }
              },
              "t": 1,
              "a": { "a": 0, "k": 0 },
              "h": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [10.017600059509277, 17.36669921875],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [10.017600059509277, 17.36669921875],
                    "t": 30
                  },
                  { "s": [10.017600059509277, 17.36669921875], "t": 60 }
                ]
              },
              "r": 1,
              "o": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [100],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [100],
                    "t": 30
                  },
                  { "s": [100], "t": 60 }
                ]
              }
            }
          ],
          "ind": 1
        },
        {
          "ty": 0,
          "nm": "Group",
          "sr": 1,
          "st": 0,
          "op": 61.12,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.85, 11.2],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.85, 11.2],
                  "t": 30
                },
                { "s": [7.85, 11.2], "t": 60 }
              ]
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 30
                },
                { "s": [100, 100], "t": 60 }
              ]
            },
            "sk": { "a": 0, "k": 0 },
            "p": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.85, 11.2],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.85, 11.2],
                  "t": 30
                },
                { "s": [7.85, 11.2], "t": 60 }
              ]
            },
            "r": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [0],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [0],
                  "t": 30
                },
                { "s": [0], "t": 60 }
              ]
            },
            "sa": { "a": 0, "k": 0 },
            "o": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 30
                },
                { "s": [100], "t": 60 }
              ]
            }
          },
          "ef": [],
          "w": 80,
          "h": 80,
          "refId": "2",
          "ind": 2
        },
        {
          "ty": 4,
          "nm": "Logo Bg",
          "sr": 1,
          "st": 0,
          "op": 61.12,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.47, 11.2],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.47, 11.2],
                  "t": 30
                },
                { "s": [7.47, 11.2], "t": 60 }
              ]
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 30
                },
                { "s": [100, 100], "t": 60 }
              ]
            },
            "sk": { "a": 0, "k": 0 },
            "p": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.47, 11.2],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.47, 11.2],
                  "t": 30
                },
                { "s": [7.47, 11.2], "t": 60 }
              ]
            },
            "r": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [0],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [0],
                  "t": 30
                },
                { "s": [0], "t": 60 }
              ]
            },
            "sa": { "a": 0, "k": 0 },
            "o": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 30
                },
                { "s": [100], "t": 60 }
              ]
            }
          },
          "ef": [],
          "shapes": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "",
              "d": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [0, 0],
                          [14.93, 0],
                          [14.93, 22.4],
                          [0, 22.4]
                        ]
                      }
                    ],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [0, 0],
                          [14.93, 0],
                          [14.93, 22.4],
                          [0, 22.4]
                        ]
                      }
                    ],
                    "t": 30
                  },
                  {
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [0, 0],
                          [14.93, 0],
                          [14.93, 22.4],
                          [0, 22.4]
                        ]
                      }
                    ],
                    "t": 60
                  }
                ]
              }
            },
            {
              "ty": "fl",
              "bm": 0,
              "hd": false,
              "nm": "",
              "c": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [1, 1, 1],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [1, 1, 1],
                    "t": 30
                  },
                  { "s": [1, 1, 1], "t": 60 }
                ]
              },
              "r": 1,
              "o": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [0],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [0],
                    "t": 30
                  },
                  { "s": [0], "t": 60 }
                ]
              }
            }
          ],
          "ind": 3
        }
      ]
    },
    {
      "nm": "[Asset] Group",
      "id": "2",
      "layers": [
        {
          "ty": 4,
          "nm": "Vector",
          "sr": 1,
          "st": 0,
          "op": 61.12,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.47, 11.2],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.47, 11.2],
                  "t": 30
                },
                { "s": [7.47, 11.2], "t": 60 }
              ]
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 30
                },
                { "s": [100, 100], "t": 60 }
              ]
            },
            "sk": { "a": 0, "k": 0 },
            "p": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.47, 11.2],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [7.47, 11.2],
                  "t": 30
                },
                { "s": [7.47, 11.2], "t": 60 }
              ]
            },
            "r": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [0],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [0],
                  "t": 30
                },
                { "s": [0], "t": 60 }
              ]
            },
            "sa": { "a": 0, "k": 0 },
            "o": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 30
                },
                { "s": [100], "t": 60 }
              ]
            }
          },
          "ef": [],
          "shapes": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "",
              "d": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 0],
                          [1.03, 0],
                          [0, 1.03],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.01, 0.21],
                          [0, 0],
                          [0, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0.01],
                          [0, 0.04],
                          [0.02, 0.1],
                          [0.44, 0.5],
                          [0.11, 0.1],
                          [0.03, 0.02],
                          [0, 0],
                          [0, 0],
                          [0, 0.4],
                          [-1.03, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.77, -2.17],
                          [0.02, -0.06],
                          [0, -0.58],
                          [-0.46, -0.81],
                          [-0.14, -0.19],
                          [-0.06, -0.07],
                          [-0.29, -0.24],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.12, -0.64],
                          [-0.01, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.58],
                          [-2.44, 0],
                          [-0.77, 2.17],
                          [0, 0.65],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 1.03],
                          [-1.03, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, 0],
                          [0, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, -0.04],
                          [-0.01, -0.1],
                          [-0.13, -0.68],
                          [-0.1, -0.11],
                          [-0.03, -0.02],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.3],
                          [0, -1.03],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-2.44, 0],
                          [-0.02, 0.06],
                          [-0.17, 0.53],
                          [0, 1],
                          [0.12, 0.21],
                          [0.05, 0.07],
                          [0.24, 0.29],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.4, 0.48],
                          [0.01, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0.65],
                          [0.77, 2.17],
                          [2.44, 0],
                          [0.21, -0.58],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [11.2, 11.52],
                          [11.2, 16.8],
                          [9.33, 18.67],
                          [7.47, 16.8],
                          [7.47, 13.88],
                          [7.47, 13.88],
                          [7.47, 11.94],
                          [7.46, 11.52],
                          [7.46, 11.52],
                          [7.46, 11.36],
                          [7.46, 11.36],
                          [7.46, 11.34],
                          [7.46, 11.32],
                          [7.45, 11.2],
                          [7.4, 10.91],
                          [6.53, 9.11],
                          [6.21, 8.8],
                          [6.13, 8.73],
                          [4.53, 7.13],
                          [4.07, 6.67],
                          [3.73, 5.6],
                          [5.6, 3.73],
                          [14.93, 3.73],
                          [14.93, 0],
                          [5.6, 0],
                          [0.32, 3.73],
                          [0.26, 3.92],
                          [0, 5.6],
                          [0.72, 8.34],
                          [1.1, 8.93],
                          [1.27, 9.15],
                          [2.06, 9.94],
                          [2.43, 10.31],
                          [2.91, 10.79],
                          [2.91, 10.8],
                          [3.71, 12.49],
                          [3.73, 12.63],
                          [3.73, 13.72],
                          [3.73, 13.73],
                          [3.73, 13.73],
                          [3.73, 16.8],
                          [4.05, 18.67],
                          [9.33, 22.4],
                          [14.61, 18.67],
                          [14.93, 16.8],
                          [14.93, 11.2],
                          [11.2, 11.2],
                          [11.2, 11.52]
                        ]
                      }
                    ],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 0],
                          [1.03, 0],
                          [0, 1.03],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.01, 0.21],
                          [0, 0],
                          [0, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0.01],
                          [0, 0.04],
                          [0.02, 0.1],
                          [0.44, 0.5],
                          [0.11, 0.1],
                          [0.03, 0.02],
                          [0, 0],
                          [0, 0],
                          [0, 0.4],
                          [-1.03, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.77, -2.17],
                          [0.02, -0.06],
                          [0, -0.58],
                          [-0.46, -0.81],
                          [-0.14, -0.19],
                          [-0.06, -0.07],
                          [-0.29, -0.24],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.12, -0.64],
                          [-0.01, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.58],
                          [-2.44, 0],
                          [-0.77, 2.17],
                          [0, 0.65],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 1.03],
                          [-1.03, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, 0],
                          [0, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, -0.04],
                          [-0.01, -0.1],
                          [-0.13, -0.68],
                          [-0.1, -0.11],
                          [-0.03, -0.02],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.3],
                          [0, -1.03],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-2.44, 0],
                          [-0.02, 0.06],
                          [-0.17, 0.53],
                          [0, 1],
                          [0.12, 0.21],
                          [0.05, 0.07],
                          [0.24, 0.29],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.4, 0.48],
                          [0.01, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0.65],
                          [0.77, 2.17],
                          [2.44, 0],
                          [0.21, -0.58],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [11.2, 11.52],
                          [11.2, 16.8],
                          [9.33, 18.67],
                          [7.47, 16.8],
                          [7.47, 13.88],
                          [7.47, 13.88],
                          [7.47, 11.94],
                          [7.46, 11.52],
                          [7.46, 11.52],
                          [7.46, 11.36],
                          [7.46, 11.36],
                          [7.46, 11.34],
                          [7.46, 11.32],
                          [7.45, 11.2],
                          [7.4, 10.91],
                          [6.53, 9.11],
                          [6.21, 8.8],
                          [6.13, 8.73],
                          [4.53, 7.13],
                          [4.07, 6.67],
                          [3.73, 5.6],
                          [5.6, 3.73],
                          [14.93, 3.73],
                          [14.93, 0],
                          [5.6, 0],
                          [0.32, 3.73],
                          [0.26, 3.92],
                          [0, 5.6],
                          [0.72, 8.34],
                          [1.1, 8.93],
                          [1.27, 9.15],
                          [2.06, 9.94],
                          [2.43, 10.31],
                          [2.91, 10.79],
                          [2.91, 10.8],
                          [3.71, 12.49],
                          [3.73, 12.63],
                          [3.73, 13.72],
                          [3.73, 13.73],
                          [3.73, 13.73],
                          [3.73, 16.8],
                          [4.05, 18.67],
                          [9.33, 22.4],
                          [14.61, 18.67],
                          [14.93, 16.8],
                          [14.93, 11.2],
                          [11.2, 11.2],
                          [11.2, 11.52]
                        ]
                      }
                    ],
                    "t": 30
                  },
                  {
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 0],
                          [1.03, 0],
                          [0, 1.03],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.01, 0.21],
                          [0, 0],
                          [0, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0.01],
                          [0, 0.04],
                          [0.02, 0.1],
                          [0.44, 0.5],
                          [0.11, 0.1],
                          [0.03, 0.02],
                          [0, 0],
                          [0, 0],
                          [0, 0.4],
                          [-1.03, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.77, -2.17],
                          [0.02, -0.06],
                          [0, -0.58],
                          [-0.46, -0.81],
                          [-0.14, -0.19],
                          [-0.06, -0.07],
                          [-0.29, -0.24],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.12, -0.64],
                          [-0.01, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.58],
                          [-2.44, 0],
                          [-0.77, 2.17],
                          [0, 0.65],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [0, 1.03],
                          [-1.03, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, 0],
                          [0, -0.05],
                          [0, 0],
                          [0, 0],
                          [0, -0.01],
                          [0, -0.04],
                          [-0.01, -0.1],
                          [-0.13, -0.68],
                          [-0.1, -0.11],
                          [-0.03, -0.02],
                          [0, 0],
                          [0, 0],
                          [-0.21, -0.3],
                          [0, -1.03],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-2.44, 0],
                          [-0.02, 0.06],
                          [-0.17, 0.53],
                          [0, 1],
                          [0.12, 0.21],
                          [0.05, 0.07],
                          [0.24, 0.29],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0.4, 0.48],
                          [0.01, 0.05],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0.65],
                          [0.77, 2.17],
                          [2.44, 0],
                          [0.21, -0.58],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [11.2, 11.52],
                          [11.2, 16.8],
                          [9.33, 18.67],
                          [7.47, 16.8],
                          [7.47, 13.88],
                          [7.47, 13.88],
                          [7.47, 11.94],
                          [7.46, 11.52],
                          [7.46, 11.52],
                          [7.46, 11.36],
                          [7.46, 11.36],
                          [7.46, 11.34],
                          [7.46, 11.32],
                          [7.45, 11.2],
                          [7.4, 10.91],
                          [6.53, 9.11],
                          [6.21, 8.8],
                          [6.13, 8.73],
                          [4.53, 7.13],
                          [4.07, 6.67],
                          [3.73, 5.6],
                          [5.6, 3.73],
                          [14.93, 3.73],
                          [14.93, 0],
                          [5.6, 0],
                          [0.32, 3.73],
                          [0.26, 3.92],
                          [0, 5.6],
                          [0.72, 8.34],
                          [1.1, 8.93],
                          [1.27, 9.15],
                          [2.06, 9.94],
                          [2.43, 10.31],
                          [2.91, 10.79],
                          [2.91, 10.8],
                          [3.71, 12.49],
                          [3.73, 12.63],
                          [3.73, 13.72],
                          [3.73, 13.73],
                          [3.73, 13.73],
                          [3.73, 16.8],
                          [4.05, 18.67],
                          [9.33, 22.4],
                          [14.61, 18.67],
                          [14.93, 16.8],
                          [14.93, 11.2],
                          [11.2, 11.2],
                          [11.2, 11.52]
                        ]
                      }
                    ],
                    "t": 60
                  }
                ]
              }
            },
            {
              "ty": "gf",
              "bm": 0,
              "hd": false,
              "nm": "",
              "e": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [7.422760009765625, 0.15892399847507477],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [7.422760009765625, 0.15892399847507477],
                    "t": 30
                  },
                  { "s": [7.422760009765625, 0.15892399847507477], "t": 60 }
                ]
              },
              "g": {
                "p": 6,
                "k": {
                  "a": 1,
                  "k": [
                    {
                      "o": { "x": 0, "y": 0 },
                      "i": { "x": 1, "y": 1 },
                      "s": [
                        0, 0.9490588265680799, 0.2902353066229353,
                        0.40396079004044627, 0.12999999523162842,
                        0.9490588265680799, 0.31376471698517894,
                        0.3961176532530317, 0.3199999928474426,
                        0.9529803949617872, 0.38827451646561717,
                        0.3843529480719099, 0.5400000214576721,
                        0.9569019633554945, 0.5059215980791578,
                        0.36082353770966624, 0.7799999713897705,
                        0.964745100142909, 0.6706274706148634,
                        0.32552942216630076, 1, 0.9725882369303236,
                        0.851019616725398, 0.29415687501664256
                      ],
                      "t": 0
                    },
                    {
                      "o": { "x": 0, "y": 0 },
                      "i": { "x": 1, "y": 1 },
                      "s": [
                        0, 0.9490588265680799, 0.2902353066229353,
                        0.40396079004044627, 0.12999999523162842,
                        0.9490588265680799, 0.31376471698517894,
                        0.3961176532530317, 0.3199999928474426,
                        0.9529803949617872, 0.38827451646561717,
                        0.3843529480719099, 0.5400000214576721,
                        0.9569019633554945, 0.5059215980791578,
                        0.36082353770966624, 0.7799999713897705,
                        0.964745100142909, 0.6706274706148634,
                        0.32552942216630076, 1, 0.9725882369303236,
                        0.851019616725398, 0.29415687501664256
                      ],
                      "t": 30
                    },
                    {
                      "s": [
                        0, 0.9490588265680799, 0.2902353066229353,
                        0.40396079004044627, 0.12999999523162842,
                        0.9490588265680799, 0.31376471698517894,
                        0.3961176532530317, 0.3199999928474426,
                        0.9529803949617872, 0.38827451646561717,
                        0.3843529480719099, 0.5400000214576721,
                        0.9569019633554945, 0.5059215980791578,
                        0.36082353770966624, 0.7799999713897705,
                        0.964745100142909, 0.6706274706148634,
                        0.32552942216630076, 1, 0.9725882369303236,
                        0.851019616725398, 0.29415687501664256
                      ],
                      "t": 60
                    }
                  ]
                }
              },
              "t": 1,
              "a": { "a": 0, "k": 0 },
              "h": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [7.669050216674805, 15.090399742126465],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [7.669050216674805, 15.090399742126465],
                    "t": 30
                  },
                  { "s": [7.669050216674805, 15.090399742126465], "t": 60 }
                ]
              },
              "r": 1,
              "o": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [100],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [100],
                    "t": 30
                  },
                  { "s": [100], "t": 60 }
                ]
              }
            }
          ],
          "ind": 1
        },
        {
          "ty": 4,
          "nm": "Vector",
          "sr": 1,
          "st": 0,
          "op": 61.12,
          "ip": 0,
          "hd": false,
          "ddd": 0,
          "bm": 0,
          "hasMask": false,
          "ao": 0,
          "ks": {
            "a": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [1.87, 1.87],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [1.87, 1.87],
                  "t": 30
                },
                { "s": [1.87, 1.87], "t": 60 }
              ]
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100, 100],
                  "t": 30
                },
                { "s": [100, 100], "t": 60 }
              ]
            },
            "sk": { "a": 0, "k": 0 },
            "p": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [13.07, 7.53],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [13.07, 7.53],
                  "t": 30
                },
                { "s": [13.07, 7.53], "t": 60 }
              ]
            },
            "r": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [-45],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [-45],
                  "t": 30
                },
                { "s": [-45], "t": 60 }
              ]
            },
            "sa": { "a": 0, "k": 0 },
            "o": {
              "a": 1,
              "k": [
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 0
                },
                {
                  "o": { "x": 0, "y": 0 },
                  "i": { "x": 1, "y": 1 },
                  "s": [100],
                  "t": 30
                },
                { "s": [100], "t": 60 }
              ]
            }
          },
          "ef": [],
          "shapes": [
            {
              "ty": "sh",
              "bm": 0,
              "hd": false,
              "nm": "",
              "d": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 1.03],
                          [1.03, 0],
                          [0, -1.03],
                          [-1.03, 0]
                        ],
                        "o": [
                          [1.03, 0],
                          [0, -1.03],
                          [-1.03, 0],
                          [0, 1.03],
                          [0, 0]
                        ],
                        "v": [
                          [1.87, 3.73],
                          [3.73, 1.87],
                          [1.87, 0],
                          [0, 1.87],
                          [1.87, 3.73]
                        ]
                      }
                    ],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 1.03],
                          [1.03, 0],
                          [0, -1.03],
                          [-1.03, 0]
                        ],
                        "o": [
                          [1.03, 0],
                          [0, -1.03],
                          [-1.03, 0],
                          [0, 1.03],
                          [0, 0]
                        ],
                        "v": [
                          [1.87, 3.73],
                          [3.73, 1.87],
                          [1.87, 0],
                          [0, 1.87],
                          [1.87, 3.73]
                        ]
                      }
                    ],
                    "t": 30
                  },
                  {
                    "s": [
                      {
                        "c": true,
                        "i": [
                          [0, 0],
                          [0, 1.03],
                          [1.03, 0],
                          [0, -1.03],
                          [-1.03, 0]
                        ],
                        "o": [
                          [1.03, 0],
                          [0, -1.03],
                          [-1.03, 0],
                          [0, 1.03],
                          [0, 0]
                        ],
                        "v": [
                          [1.87, 3.73],
                          [3.73, 1.87],
                          [1.87, 0],
                          [0, 1.87],
                          [1.87, 3.73]
                        ]
                      }
                    ],
                    "t": 60
                  }
                ]
              }
            },
            {
              "ty": "gf",
              "bm": 0,
              "hd": false,
              "nm": "",
              "e": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [2.9823999404907227, 0.6533390283584595],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [2.9823999404907227, 0.6533390283584595],
                    "t": 30
                  },
                  { "s": [2.9823999404907227, 0.6533390283584595], "t": 60 }
                ]
              },
              "g": {
                "p": 6,
                "k": {
                  "a": 1,
                  "k": [
                    {
                      "o": { "x": 0, "y": 0 },
                      "i": { "x": 1, "y": 1 },
                      "s": [
                        0, 0.9490588265680799, 0.2902353066229353,
                        0.40396079004044627, 0.12999999523162842,
                        0.9490588265680799, 0.3176862853788862,
                        0.3961176532530317, 0.3199999928474426,
                        0.9529803949617872, 0.3961176532530317,
                        0.3804313796782026, 0.550000011920929,
                        0.9569019633554945, 0.5216078716539869,
                        0.35690196931595897, 0.8100000023841858,
                        0.964745100142909, 0.6980784493708143,
                        0.3216078537725935, 1, 0.9725882369303236,
                        0.851019616725398, 0.29415687501664256
                      ],
                      "t": 0
                    },
                    {
                      "o": { "x": 0, "y": 0 },
                      "i": { "x": 1, "y": 1 },
                      "s": [
                        0, 0.9490588265680799, 0.2902353066229353,
                        0.40396079004044627, 0.12999999523162842,
                        0.9490588265680799, 0.3176862853788862,
                        0.3961176532530317, 0.3199999928474426,
                        0.9529803949617872, 0.3961176532530317,
                        0.3804313796782026, 0.550000011920929,
                        0.9569019633554945, 0.5216078716539869,
                        0.35690196931595897, 0.8100000023841858,
                        0.964745100142909, 0.6980784493708143,
                        0.3216078537725935, 1, 0.9725882369303236,
                        0.851019616725398, 0.29415687501664256
                      ],
                      "t": 30
                    },
                    {
                      "s": [
                        0, 0.9490588265680799, 0.2902353066229353,
                        0.40396079004044627, 0.12999999523162842,
                        0.9490588265680799, 0.3176862853788862,
                        0.3961176532530317, 0.3199999928474426,
                        0.9529803949617872, 0.3961176532530317,
                        0.3804313796782026, 0.550000011920929,
                        0.9569019633554945, 0.5216078716539869,
                        0.35690196931595897, 0.8100000023841858,
                        0.964745100142909, 0.6980784493708143,
                        0.3216078537725935, 1, 0.9725882369303236,
                        0.851019616725398, 0.29415687501664256
                      ],
                      "t": 60
                    }
                  ]
                }
              },
              "t": 1,
              "a": { "a": 0, "k": 0 },
              "h": { "a": 0, "k": 0 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [0.4551979899406433, 3.4015700817108154],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [0.4551979899406433, 3.4015700817108154],
                    "t": 30
                  },
                  { "s": [0.4551979899406433, 3.4015700817108154], "t": 60 }
                ]
              },
              "r": 1,
              "o": {
                "a": 1,
                "k": [
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [100],
                    "t": 0
                  },
                  {
                    "o": { "x": 0, "y": 0 },
                    "i": { "x": 1, "y": 1 },
                    "s": [100],
                    "t": 30
                  },
                  { "s": [100], "t": 60 }
                ]
              }
            }
          ],
          "ind": 2
        }
      ]
    }
  ]
}
